import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20background%20with%20soft%20flowing%20gradients%20in%20terracotta%20coral%20and%20warm%20cream%20tones%2C%20gentle%20overlapping%20circles%20and%20waves%2C%20modern%20minimalist%20abstract%20art%2C%20soft%20diffused%20light%2C%20harmonious%20peaceful%20atmosphere%2C%20no%20text%2C%20clean%20design&width=1800&height=900&seq=hero-bg-community&orientation=landscape"
          alt="男同社区背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-4xl md:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          找到属于你的
          <br />
          <span className="text-accent-400">彩虹社区</span>
        </h1>
        <p className="text-lg md:text-xl text-background-50/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          安全、温暖、真实的男同交友与资讯平台。在这里找到志同道合的伙伴，分享生活经历，获取LGBTQ+相关资讯，建立真实有意义的连接。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/jiaoyou"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border-2 border-background-50/40 text-background-50 rounded-full text-base font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}